import React, { useEffect, useState, useRef } from "react"
import "./ViewAppUser.scss"
import UserPostFeed from "./UserPostFeed/UserPostFeed"
import { useNavigate, useParams } from "react-router-dom"
import AuthenticationApi from "Api/AuthenticationApi"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Chip } from "primereact/chip"
import { Calendar } from "primereact/calendar"
import { MultiSelect } from "primereact/multiselect"
import { Card, CardBody, Col, Row, Button, Input } from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { Country, State } from "country-state-city"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { ProgressSpinner } from "primereact/progressspinner"
import defaultAvatar from "assets/images/man.png"
import "flag-icons/css/flag-icons.min.css"
import UserSettingApi from "Api/UserSettingApi"
import EncryptPassword from "utils/EncryptPassword/EncryptPassword"
import { Toast } from "primereact/toast"
import { InputSwitch } from "primereact/inputswitch"
import CreatorApi from "Api/CreatorApi"
import { Accordion, AccordionTab } from "primereact/accordion"
import { Badge } from "primereact/badge"
import ResetPasswordSection from 'components/ResetPasswordSection'
import PaymentApi from "Api/paymentApi"

const ViewAppUser = () => {
  const navigate = useNavigate()
  const { userId } = useParams()
  const accessToken = localStorage.getItem("accessToken")

  const [isEditing, setIsEditing] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingStates, setLoadingStates] = useState(false)
  const [countries, setCountries] = useState([])
  const [states, setStates] = useState([])
  const [originalData, setOriginalData] = useState({})
  const [activeTab, setActiveTab] = useState("personal-info")
  const [lockReason, setLockReason] = useState("")
  const [showLockReason, setShowLockReason] = useState(false)
  const [otp, setOtp] = useState("")
  const [reason, setReason] = useState("")
  const [modal, setModal] = useState(false)
  const [connectionType, setConnectionType] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10
  const [searchTerm, setSearchTerm] = useState("")
  const [filteredConnections, setFilteredConnections] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const toast = useRef(null)
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false)
  const [twoFactorAuthType, setTwoFactorAuthType] = useState("email")
  const [showTypeSelector, setShowTypeSelector] = useState(false)
  const [resetPasswordLoading, setResetPasswordLoading] = useState(false)
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [paymentHistoryModal, setPaymentHistoryModal] = useState(false);
  const [paymentHistoryLoading, setPaymentHistoryLoading] = useState(false);
  const [parentDetailsLoading, setParentDetailsLoading] = useState(false);
  const [parentDetailsModal, setParentDetailsModal] = useState(false);
  const [deleteParentModal, setDeleteParentModal] = useState(false);
  const [selectedParentId, setSelectedParentId] = useState(null);
  const [deleteParentLoading, setDeleteParentLoading] = useState(false);

  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    userName: "",
    userType: "",
    dob: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    description: "",
    gender: "",
    creatorCategory: "",
    targetAudience: "",
    bio: "",
    profilePicture: "",
    isPublic: true,
    followers: [],
    following: [],
    posts: [],
  })

  const [bankDetails, setBankDetails] = useState({
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    accountHolderName: "",
    accountType: "",
    branchName: "",
    upiId: "",
    verificationReferenceId: "",
    accountHolderEmail: "",
    accountHolderPhone: "",
    aadharNumber: "",
    panNumber: "",
    isAccountVerified: false,
    isAadharVerified: false,
    isPanVerified: false,
  });

  const [decryptionError, setDecryptionError] = useState(null);

  const [visibleFields, setVisibleFields] = useState({
    accountNumber: false,
    aadharNumber: false,
    panNumber: false,
    ifscCode: false,
    upiId: false,
    accountHolderName: false,
    accountType: false,
    accountHolderAddress: false,
    accountHolderEmail: false,
    accountHolderPhone: false,
    bankName: false,
  });

  const [notificationSettings, setNotificationSettings] = useState({
    // circle: false,
    // call: false,
    // message: false,
    // event: false
    isDobVisible: false,
    isEmailVisible: false,
    isPhoneVisible: false,
    messagePrivacy: ""
  });

  const [userSettings, setUserSettings] = useState(null);

  const fetchUserSettings = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await UserSettingApi.fetchUserSettings(userData.userId, config);
      if (response.data.status) {
        const settings = response.data.data;
        setUserSettings(settings);

        setNotificationSettings({
          circle: settings.enableCircleNotifications || false,
          call: settings.enableCallNotifications || false,
          message: settings.enableMessageNotifications || false,
          event: settings.enableEventNotifications || false
        });

        setTwoFactorEnabled(settings.isTwoFactEnabled || false);
        setTwoFactorAuthType(settings.isTwoFactMethod || 'email');
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    if (userData.userId) {
      fetchUserSettings();

    }
  }, [userData.userId]);

  const breadcrumbItems = [
    { label: "Home", link: "/" },
    { label: "Users", link: "/user-list" },
    { label: "User Profile", link: "#" },
  ]
  const handleBreadcrumbClick = link => {
    if (link !== "#") {
      navigate(link)
    }
  }
  const sidebarItems = [
    { icon: "person", label: "Personal Information", id: "personal-info" },
    { icon: "people", label: "View Connections", id: "View Connections" },
    { icon: "post", label: "View Posts", id: "View Posts" },
    ...(userData.userType === "creator" ? [{ icon: "card", label: "Bank Details", id: "bank-details" }] : []),
    { icon: "gear", label: "Settings", id: "settings" },
  ]
  const getPaginatedData = (items = []) => {
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    return items.slice(startIndex, endIndex)
  }
  const filterConnections = (connections, term) => {
    if (!term.trim()) return connections

    return connections.filter(
      user =>
        user.firstName.toLowerCase().includes(term.toLowerCase()) ||
        user.lastName.toLowerCase().includes(term.toLowerCase()) ||
        user.userName.toLowerCase().includes(term.toLowerCase()) ||
        user.userType.toLowerCase().includes(term.toLowerCase()),
    )
  }

  const skillsList = [
    { label: "Adobe XD", value: "Adobe XD" },
    { label: "Angular", value: "Angular" },
    { label: "Corel Draw", value: "Corel Draw" },
    { label: "Figma", value: "Figma" },
    { label: "HTML", value: "HTML" },
    { label: "Illustrator", value: "Illustrator" },
    { label: "Javascript", value: "Javascript" },
    { label: "Logo Design", value: "Logo Design" },
    { label: "Material UI", value: "Material UI" },
    { label: "NodeJS", value: "NodeJS" },
    { label: "npm", value: "npm" },
    { label: "Photoshop", value: "Photoshop" },
    { label: "React", value: "React" },
    { label: "Redux-toolkit", value: "Redux-toolkit" },
    { label: "SASS", value: "SASS" },
  ]
  useEffect(() => {
    const allCountries = Country.getAllCountries().map(country => ({
      label: country.name,
      value: country.isoCode,
      flag: country.flag,
    }))
    setCountries(allCountries)
  }, [])
  // useEffect(() => {
  //   const fetchTwoFactorSettings = async () => {
  //     try {
  //       const config = {
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //       }
  //       const response = await UserSettingApi.getTwoFactorSettings(
  //         userData.userId,
  //         config,
  //       )
  //       if (response.data.status) {
  //         setTwoFactorEnabled(response.data.data.isTwoFactorAuthEnabled)
  //         setTwoFactorAuthType(response.data.data.twoFactorAuthType || "email")

  //         setShowTypeSelector(false)
  //       }
  //     } catch (error) {
  //       console.error("Error fetching 2FA settings:", error)
  //       toast.current.show({
  //         severity: "error",
  //         summary: "Error",
  //         detail: "Failed to fetch 2FA settings",
  //         life: 3000,
  //       })
  //     }
  //   }

  //   if (userData.userId) {
  //     fetchTwoFactorSettings()
  //   }
  // }, [userData.userId])

  const toggle = () => {
    setModal(!modal)
    if (!modal) {
      setOtp("")
      setReason("")
    }
  }

  const formatDateForInput = dateString => {
    if (!dateString) return ""
    const [day, month, year] = dateString.split("/")
    if (day && month && year) {
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
    }
    return dateString
  }

  const findCountryByName = countryName => {
    return Country.getAllCountries().find(
      country => country?.name?.toLowerCase() === countryName.toLowerCase(),
    )
  }

  const findStateByName = (countryCode, stateName) => {
    return State.getStatesOfCountry(countryCode).find(
      state => state.name.toLowerCase() === stateName.toLowerCase(),
    )
  }

  const handleInputChange = (e, field) => {
    try {
      let value = (e && Object.prototype.hasOwnProperty.call(e, 'value')) ? e.value : e?.target?.value

      if (field === "dob") {
        const [year, month, day] = value.split("-")
        if (year && month && day) {
          value = `${day}/${month}/${year}`
        }
      }

      if (field === "country") {
        setUserData(prev => ({
          ...prev,
          country: value,
          state: "",
        }))
      } else {
        setUserData(prev => ({
          ...prev,
          [field]: value,
        }))
      }
    } catch (error) {
      console.error("Error updating field:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: `Failed to update ${field}`,
        life: 3000,
      })
      // toast.error(`Failed to update ${field}`)
    }
  }

  const validateForm = () => {
    const requiredFields = ["firstName", "lastName", "email", "country"]
    const missingFields = requiredFields.filter(field => !userData[field])

    if (missingFields.length > 0) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please fill in all required fields",
        life: 3000,
      })
      // toast.error("Please fill in all required fields")
      return false
    }

    if (userData.country && !userData.state) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please select a state/province",
        life: 3000,
      })
      // toast.error("Please select a state/province")
      return false
    }

    return true
  }

  const handleEdit = () => {
    setOriginalData({ ...userData })
    setIsEditing(true)
  }

  const handleCancel = () => {
    setUserData(originalData)
    setIsEditing(false)
  }

  const handleSave = async () => {
    if (!validateForm()) return

    try {
      setLoading(true)
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }

      const selectedCountry = Country.getAllCountries().find(
        c => c.isoCode === userData.country,
      )
      const selectedState = State.getStatesOfCountry(userData.country).find(
        s => s.isoCode === userData.state,
      )

      const dataToSend = {
        ...userData,
        country: selectedCountry ? selectedCountry.name : "",
        state: selectedState ? selectedState.name : "",
      }

      await AuthenticationApi.updateUser(userId, dataToSend, config)

      setIsEditing(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Profile updated successfully",
        life: 3000,
      })
    } catch (error) {
      console.error("Error updating profile:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message || "Failed to update profile",
        life: 3000,
      })
    } finally {
      setLoading(false)
    }
  }

  const getUserData = async () => {
    try {
      setLoading(true)
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
      const response = await AuthenticationApi.getUserById(userId, config)
      if (response.data.status && response.data.data) {
        const userData = response.data.data

        const countryObj = findCountryByName(userData.address[0].country)
        let stateObj = null
        if (countryObj) {
          stateObj = findStateByName(countryObj.isoCode, userData.address[0].state)
          console.log(stateObj)
        }

        setUserData(prev => ({
          ...prev,
          ...userData,
          dob: formatDateForInput(userData.dob),
          country: countryObj ? countryObj.isoCode : "",
          state: stateObj ? stateObj.isoCode : "",
          posts: userData.posts,
          firstName: userData.firstName,
          lastName: userData.lastName,
          email: userData.email,
          userName: userData.userName,
          city: userData.address[0].city,
          zipCode: userData.address[0].zipCode,
          description: userData.description,
          gender: userData.gender,
          creatorCategory: userData.creatorCategory,
          targetAudience: userData.targetAudience,
          bio: userData.bio,
          profilePicture: userData.profilePicture,
          userId: userData.userId,
        }))

        // Populate states list based on fetched country
        if (countryObj?.isoCode) {
          setLoadingStates(true)
          const stateOptions = State.getStatesOfCountry(countryObj.isoCode).map(s => ({
            label: s.name,
            value: s.isoCode,
          }))
          setStates(stateOptions)
          setLoadingStates(false)
        } else {
          setStates([])
        }
      }
    } catch (error) {
      console.error("Error fetching user data:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message || "Failed to fetch user data",
        life: 3000,
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (userId) {
      getUserData()
    }
  }, [userId])

  // Load states when country changes
  useEffect(() => {
    try {
      if (!userData.country) {
        setStates([])
        return
      }
      setLoadingStates(true)
      const stateOptions = State.getStatesOfCountry(userData.country).map(s => ({
        label: s.name,
        value: s.isoCode,
      }))
      setStates(stateOptions)
    } catch (err) {
      setStates([])
    } finally {
      setLoadingStates(false)
    }
  }, [userData.country])

  useEffect(() => {
    const fetchBankDetails = async () => {
      if (userData.userId && userData.userType === "creator") {
        try {
          const config = {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }

          const response = await CreatorApi.getCreatorDetails(userData.userId, config);

          if (response.data.success && response.data.data) {
            const encryptedData = response.data.data;

            try {
              const decrypted = EncryptPassword.DecryptBankDetails(encryptedData);
              let bankData = {};
              console.log(decrypted)

              if (decrypted && Array.isArray(decrypted) && decrypted.length > 0) {
                bankData = decrypted[0]; // Get the first object from the array
              } else if (decrypted && typeof decrypted === 'object' && !Array.isArray(decrypted)) {
                bankData = decrypted;
              }

              const updatedBankDetails = {
                bankName: bankData.bankName || "",
                accountNumber: bankData.accountNumber || "",
                ifscCode: bankData.ifscCode || "",
                accountHolderName: bankData.accountHolderName || "",
                accountType: bankData.accountType || "",
                branchName: bankData.branchName || "",
                upiId: bankData.upiId || "",
                verificationReferenceId: bankData.verificationReferenceId || "",
                accountHolderEmail: bankData.accountHolderEmail || "",
                accountHolderPhone: bankData.accountHolderPhone || "",
                aadharNumber: bankData.aadharNumber || "",
                panNumber: bankData.panNumber || "",
                isAccountVerified: bankData.isAccountVerified || false,
                isAadharVerified: bankData.isAadharVerified || false,
                isPanVerified: bankData.isPanVerified || false,
              };

              setBankDetails(updatedBankDetails);
              setDecryptionError(null);
            } catch (error) {
              console.error("Decryption error:", error.message);
              // Don't set error, just use empty bank details
              // No toast notification for error
            }
          }
          // No else branch to handle missing data - just use the default empty bank details
        } catch (error) {
          console.error("API error:", error.message);
          // Don't set error, just use empty bank details
          // No toast notification for error
        }
      }
    }

    fetchBankDetails();
  }, [userData.userId, userData.userType, accessToken]);

  // useEffect(() => {
  //   const fetchTwoFactorSettings = () => {
  //     const config = {
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //     }

  //     UserSettingApi.getTwoFactorSettings(userData.userId, config)
  //       .then(response => {
  //         if (response.data.status) {
  //           setTwoFactorEnabled(response.data.data.isTwoFactorAuthEnabled)
  //           setTwoFactorAuthType(
  //             response.data.data.twoFactorAuthType || "email",
  //           )
  //         }
  //       })
  //       .catch(error => {
  //         console.error("Error fetching 2FA settings:", error)
  //         toast.current.show({
  //           severity: "error",
  //           summary: "Error",
  //           detail: "Failed to fetch 2FA settings",
  //           life: 3000,
  //         })
  //       })
  //   }

  //   if (userData.userId) {
  //     fetchTwoFactorSettings()
  //   }
  // }, [userData.userId])

  const countryOptionTemplate = option => {
    return (
      <div className="country-option">
        <span className={`fi fi-${option.value.toLowerCase()}`}></span>
        <span className="ml-2">{option.label}</span>
      </div>
    )
  }

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="country-option">
          <span className={`fi fi-${option.value.toLowerCase()}`}></span>
          <span className="ml-2">{option.label}</span>
        </div>
      )
    }
    return <span>{props.placeholder}</span>
  }

  const renderProfileHeader = () => (
    <Card className="mt-4 bg-light">
      <CardBody className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-4">
          <div className="progress-circle">
            <span>{userData.profileCompletion}</span>
          </div>
          <div>
            <h5 className="mb-1">Edit Your Profile</h5>
            <p className="mb-0 text-muted">
              Complete your profile to unlock all features
            </p>
          </div>
        </div>
        {activeTab === "personal-info" && (
          <Button
            color="primary"
            onClick={isEditing ? handleSave : handleEdit}
            disabled={loading}
          >
            {loading ? (
              <ProgressSpinner style={{ width: "20px", height: "20px" }} />
            ) : isEditing ? (
              "Save Profile"
            ) : (
              "Edit Profile"
            )}
          </Button>
        )}
      </CardBody>
    </Card>
  )
  useEffect(() => {
    setFilteredConnections(
      filterConnections(
        connectionType === "followers"
          ? userData.followers
          : userData.following || [],
        searchTerm,
      ),
    )
    setCurrentPage(1)
  }, [userData, searchTerm, connectionType])
  const renderConnections = () => {
    const totalPages = Math.ceil(
      (filteredConnections?.length || 0) / itemsPerPage,
    )

    return (
      <div className="connections-container " style={{ height: "100%" }}>
        <Card style={{ height: "100%" }}>
          <CardBody style={{ height: "100%" }}>
            <div className="mb-4 ">
              <div className="d-flex justify-content-between align-items-center">
                <div className="connection-tabs">
                  <ul className="nav nav-tabs">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${connectionType === "followers" ? "active" : ""}`}
                        onClick={() => setConnectionType("followers")}
                      >
                        Followers ({userData.followers?.length || 0})
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${connectionType === "following" ? "active" : ""}`}
                        onClick={() => setConnectionType("following")}
                      >
                        Following ({userData.following?.length || 0})
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="search-box">
                  <div className="position-relative">
                    <InputText
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={e => setSearchTerm(e.target.value)}
                      className="p-inputtext-sm"
                    />
                    <i
                      className="pi pi-search position-absolute"
                      style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#6c757d",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="connections-list">
              {filteredConnections?.length > 0 ? (
                <>
                  {getPaginatedData(filteredConnections).map(user => (
                    <div
                      key={user._id}
                      className="connection-item d-flex align-items-center p-3 border-bottom"
                    >
                      <img
                        src={user.profilePicture || defaultAvatar}
                        alt={
                          connectionType === "followers"
                            ? "follower"
                            : "following"
                        }
                        className="rounded-circle me-3"
                        width="50"
                        height="50"
                        style={{ objectFit: "cover" }}
                      />
                      <div className="user-info">
                        <h6 className="mb-0">
                          {`${user.firstName} ${user.lastName}`}
                        </h6>
                        <p className="text-muted small mb-0">{user.userType}</p>
                        <p className="text-muted small mb-0">
                          @{user.userName}
                        </p>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <p className="text-muted text-center">
                  {searchTerm
                    ? "No matching connections found"
                    : connectionType === "followers"
                      ? "No followers yet"
                      : connectionType === "following"
                        ? "Not following anyone"
                        : "Select Followers or Following to view connections"}
                </p>
              )}
            </div>

            {/* Pagination Controls */}
            {filteredConnections?.length > itemsPerPage && (
              <div className="pagination-container mt-3 d-flex justify-content-center">
                <nav>
                  <ul className="pagination">
                    <li
                      className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          setCurrentPage(prev => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                    </li>

                    {[...Array(totalPages)].map((_, index) => (
                      <li
                        key={index + 1}
                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}

                    <li
                      className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          setCurrentPage(prev => Math.min(prev + 1, totalPages))
                        }
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </CardBody>
        </Card>
      </div>
    )
  }
  const renderPosts = () => {
    return <UserPostFeed userData={userData} />
  }

  const renderSidebar = () => (
    <Card className="h-100">
      <CardBody>
        <div className="text-center">
          <div className="profile-image mb-4">
            <img
              src={userData.profilePicture || defaultAvatar}
              alt="Profile"
              className="rounded-circle img-thumbnail"
              width="120"
            />
            {isEditing && activeTab === "personal-info" && (
              <div className="image-upload-overlay">
                <Button color="light" size="sm">
                  <i className="ion ion-md-camera"></i>
                </Button>
              </div>
            )}
          </div>
          <h4>{userData.userName}</h4>
          <p className="text-muted">{userData.userType}</p>

          <div className="d-flex justify-content-around mt-4">
            <div
              className="text-center"
              onClick={() => {
                setActiveTab("View Posts")
              }}
              style={{ cursor: "pointer" }}
              role="button"
              title="View Posts"
            >
              <h4>{userData.posts?.length || 0}</h4>
              <p className="text-muted">Posts</p>
            </div>
            <div
              className="text-center"
              onClick={() => {
                setActiveTab("View Connections")
                setConnectionType("followers")
              }}
              style={{ cursor: "pointer" }}
              role="button"
              title="View Followers"
            >
              <h4>{userData.followers?.length || 0}</h4>
              <p className="text-muted">Followers</p>
            </div>
            <div
              className="text-center"
              onClick={() => {
                setActiveTab("View Connections")
                setConnectionType("following")
              }}
              style={{ cursor: "pointer" }}
              role="button"
              title="View Following"
            >
              <h4>{userData.following?.length || 0}</h4>
              <p className="text-muted">Following</p>
            </div>
          </div>
        </div>

        <div className="profile-navigation mt-4">
          {sidebarItems.map(item => (
            <div
              key={item.id}
              className={`nav-item d-flex align-items-center p-3 ${activeTab === item.id ? "active" : ""}`}
              onClick={() => setActiveTab(item.id)}
              style={{ cursor: "pointer" }}
            >
              <i className={`ion ion-${item.icon} me-2`}></i>
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  )

  const renderLocationFields = () => {
    return (
      <>
        <Col md="6" className="mb-3">
          <label className="form-label">
            Country <span className="text-danger">*</span>
          </label>
          <Dropdown
            value={userData.country}
            options={countries}
            onChange={e => handleInputChange(e, "country")}
            optionLabel="label"
            optionValue="value"
            placeholder="Select a Country"
            filter
            filterBy="label"
            itemTemplate={countryOptionTemplate}
            valueTemplate={selectedCountryTemplate}
            disabled={!isEditing}
            className={`w-100 ${!userData.country && isEditing ? "p-invalid" : ""}`}
          />
        </Col>

        <Col md="6" className="mb-3">
          <label className="form-label">
            State/Province <span className="text-danger">*</span>
          </label>
          <Dropdown
            value={userData.state}
            options={states}
            onChange={e => handleInputChange(e, "state")}
            optionLabel="label"
            optionValue="value"
            placeholder={
              userData.country ? "Select a State" : "Select Country First"
            }
            filter
            filterBy="label"
            disabled={!isEditing || !userData.country || loadingStates}
            className={`w-100 ${!userData.state && userData.country && isEditing ? "p-invalid" : ""}`}
            loading={loadingStates}
          />
        </Col>
      </>
    )
  }

  const renderAdditionalFields = () => (
    <>
      <Col md="6" className="mb-3">
        <label className="form-label">Gender</label>
        <Dropdown
          value={userData.gender}
          options={[
            { label: "Male", value: "Male" },
            { label: "Female", value: "Female" },
            { label: "Other", value: "Other" },
          ]}
          onChange={e => handleInputChange(e, "gender")}
          placeholder="Select Gender"
          disabled={!isEditing}
          className="w-100"
        />
      </Col>
      <Col md="6" className="mb-3">
        <label className="form-label">Creator Category</label>
        <InputText
          value={userData.creatorCategory}
          onChange={e => handleInputChange(e, "creatorCategory")}
          disabled={!isEditing}
          className="w-100"
        />
      </Col>
      <Col md="6" className="mb-3">
        <label className="form-label">Target Audience</label>
        <InputText
          value={userData.targetAudience}
          onChange={e => handleInputChange(e, "targetAudience")}
          disabled={!isEditing}
          className="w-100"
        />
      </Col>
      <Col md="12" className="mb-3">
        <label className="form-label">Bio</label>
        <InputText
          value={userData.bio}
          onChange={e => handleInputChange(e, "bio")}
          className="w-100"
          disabled={!isEditing}
        />
      </Col>
    </>
  )

  const renderFormField = (
    label,
    field,
    type = "text",
    options = null,
    required = false,
  ) => {
    return (
      <Col md="6" className="mb-3">
        <label className="form-label">
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
        {type === "date" ? (
          <Calendar
            value={userData[field] ? new Date(userData[field]) : null}
            onChange={e => handleInputChange(e, field)}
            disabled={!isEditing}
            dateFormat="dd/mm/yy"
            showIcon
            className={`w-100 ${!userData[field] && required && isEditing ? "p-invalid" : ""}`}
            maxDate={new Date()}
          />
        ) : (
          <InputText
            value={userData[field]}
            onChange={e => handleInputChange(e, field)}
            disabled={!isEditing}
            className={`w-100 ${!userData[field] && required && isEditing ? "p-invalid" : ""}`}
          />
        )}
      </Col>
    )
  }

  const renderPersonalInformation = () => (
    <Card className="h-100">
      <CardBody style={{ height: "100%", overflowY: "auto" }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="mb-0">Personal Information</h5>
          <div>
            {/* {isEditing ? (
              <div className="d-flex gap-2">
                <Button
                  color="secondary"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  Cancel
                </Button>
                <Button color="primary" onClick={handleSave} disabled={loading}>
                  {loading ? (
                    <ProgressSpinner
                      style={{ width: "20px", height: "20px" }}
                    />
                  ) : (
                    "Save Profile"
                  )}
                </Button>
              </div>
            ) : (
              <Button color="primary" onClick={handleEdit} disabled={loading}>
                Edit Profile
              </Button>
            )} */}
          </div>
        </div>

        <Row className=" pb-3">
          {renderFormField("First Name", "firstName", "text", null, true)}
          {renderFormField("Last Name", "lastName", "text", null, true)}
          {renderFormField("Email Address", "email", "text", null, true)}
          {renderFormField("Username", "userName", "text", null, true)}
          {renderFormField("Date of Birth", "dob", "date")}
          {renderLocationFields()}
          {renderFormField("City", "city")}
          {renderFormField("Zip Code", "zipCode")}
          {renderFormField("Description", "description")}
          {renderAdditionalFields()}
        </Row>
      </CardBody>
    </Card>
  )

  const toggleFieldVisibility = (field) => {
    setVisibleFields(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const maskData = (data, isVisible, maskChar = '*') => {
    if (!data) return '';
    if (isVisible) return data;

    const visibleStart = data.substring(0, 2);
    const visibleEnd = data.substring(data.length - 2);
    const maskedPart = maskChar.repeat(data.length - 4);

    return `${visibleStart}${maskedPart}${visibleEnd}`;
  };

  const toggleAllFieldsVisibility = (visible) => {
    setVisibleFields({
      accountNumber: visible,
      aadharNumber: visible,
      panNumber: visible,
      ifscCode: visible,
      upiId: visible,
      accountHolderName: visible,
      accountHolderType: visible,
      accountHolderAddress: visible,
      accountHolderEmail: visible,
      accountHolderPhone: visible,
      bankName: visible,
    });
  };

  const renderBankDetails = () => {
    const allVisible = Object.values(visibleFields).every(value => value === true);

    return (
      <Card className="h-100">
        <CardBody style={{ height: "100%", overflowY: "auto" }}>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="mb-0">Bank Details</h5>
            <Button
              color="light"
              size="sm"
              onClick={() => toggleAllFieldsVisibility(!allVisible)}
              className="d-flex align-items-center gap-2"
            >
              <i className={`ml-1 mdi ${allVisible ? 'mdi-eye-off' : 'mdi-eye'}`}></i>
              {allVisible ? 'Hide All Details' : 'Show All Details'}
            </Button>
          </div>

          <Row className="pb-3">
            <Col md="6" className="mb-3">
              <label className="form-label">Account Holder Name</label>
              <InputText
                value={bankDetails.accountHolderName}
                disabled={true}
                className="w-100"
              />
            </Col>
            <Col md="6" className="mb-3">
              <label className="form-label">Bank Name</label>
              <InputText
                value={bankDetails.bankName}
                disabled={true}
                className="w-100"
              />
            </Col>
            <Col md="6" className="mb-3">
              <label className="form-label">Account Number</label>
              <div className="p-inputgroup">
                <InputText
                  value={maskData(bankDetails.accountNumber, visibleFields.accountNumber)}
                  disabled={true}
                  className="w-100"
                />
                <span className="p-inputgroup-addon cursor-pointer" onClick={() => toggleFieldVisibility('accountNumber')}>
                  <i className={`ml-1 mdi ${visibleFields.accountNumber ? 'mdi-eye-off' : 'mdi-eye'}`}></i>
                </span>
              </div>
            </Col>
            <Col md="6" className="mb-3">
              <label className="form-label">IFSC Code</label>
              <div className="p-inputgroup">
                <InputText
                  value={maskData(bankDetails.ifscCode, visibleFields.ifscCode)}
                  disabled={true}
                  className="w-100"
                />
                <span className="p-inputgroup-addon cursor-pointer" onClick={() => toggleFieldVisibility('ifscCode')}>
                  <i className={`ml-1 mdi ${visibleFields.ifscCode ? 'mdi-eye-off' : 'mdi-eye'}`}></i>
                </span>
              </div>
            </Col>
            <Col md="6" className="mb-3">
              <label className="form-label">Account Holder Type</label>
              <InputText
                value={bankDetails.accountType}
                disabled={true}
                className="w-100"
              />
            </Col>
            <Col md="6" className="mb-3">
              <label className="form-label">Branch Name</label>
              <InputText
                value={bankDetails.branchName}
                disabled={true}
                className="w-100"
              />
            </Col>
            <Col md="6" className="mb-3">
              <label className="form-label">UPI ID</label>
              <div className="p-inputgroup">
                <InputText
                  value={maskData(bankDetails.upiId, visibleFields.upiId)}
                  disabled={true}
                  className="w-100"
                />
                <span className="p-inputgroup-addon cursor-pointer" onClick={() => toggleFieldVisibility('upiId')}>
                  <i className={`ml-1 mdi ${visibleFields.upiId ? 'mdi-eye-off' : 'mdi-eye'}`}></i>
                </span>
              </div>
            </Col>
            <Col md="6" className="mb-3">
              <label className="form-label">Verification ReferenceId</label>
              <InputText
                value={bankDetails.verificationReferenceId}
                disabled={true}
                className="w-100"
              />
            </Col>
            {/* <Col md="6" className="mb-3">
              <label className="form-label">Email</label>
              <InputText
                value={bankDetails.accountHolderEmail}
                disabled={true}
                className="w-100"
              />
            </Col>
            <Col md="6" className="mb-3">
              <label className="form-label">Phone</label>
              <InputText
                value={bankDetails.accountHolderPhone}
                disabled={true}
                className="w-100"
              />
            </Col>
            <Col md="6" className="mb-3">
              <label className="form-label">Aadhar Number</label>
              <div className="p-inputgroup">
                <InputText
                  value={maskData(bankDetails.aadharNumber, visibleFields.aadharNumber)}
                  disabled={true}
                  className="w-100"
                />
                <span className="p-inputgroup-addon cursor-pointer" onClick={() => toggleFieldVisibility('aadharNumber')}>
                  <i className={`ml-1 mdi ${visibleFields.aadharNumber ? 'mdi-eye-off' : 'mdi-eye'}`}></i>
                </span>
              </div>
            </Col>
            <Col md="6" className="mb-3">
              <label className="form-label">PAN Number</label>
              <div className="p-inputgroup">
                <InputText
                  value={maskData(bankDetails.panNumber, visibleFields.panNumber)}
                  disabled={true}
                  className="w-100"
                />
                <span className="p-inputgroup-addon cursor-pointer" onClick={() => toggleFieldVisibility('panNumber')}>
                  <i className={`ml-1 mdi ${visibleFields.panNumber ? 'mdi-eye-off' : 'mdi-eye'}`}></i>
                </span>
              </div>
            </Col> */}
          </Row>

          {/* <div className="mt-4 mb-5">
            <h6 className="mb-3">Verification Status</h6>
            <Row>
              <Col md="4" className="mb-3">
                <div className="verification-item p-3 border rounded">
                  <label className="form-label d-block mb-2">Account Verified</label>
                  <span className={`badge ${bankDetails.isAccountVerified ? 'bg-success' : 'bg-danger'}`}>
                    {bankDetails.isAccountVerified ? 'Yes' : 'No'}
                  </span>
                </div>
              </Col>
              <Col md="4" className="mb-3">
                <div className="verification-item p-3 border rounded">
                  <label className="form-label d-block mb-2">Aadhar Verified</label>
                  <span className={`badge ${bankDetails.isAadharVerified ? 'bg-success' : 'bg-danger'}`}>
                    {bankDetails.isAadharVerified ? 'Yes' : 'No'}
                  </span>
                </div>
              </Col>
              <Col md="4" className="mb-3">
                <div className="verification-item p-3 border rounded">
                  <label className="form-label d-block mb-2">PAN Verified</label>
                  <span className={`badge ${bankDetails.isPanVerified ? 'bg-success' : 'bg-danger'}`}>
                    {bankDetails.isPanVerified ? 'Yes' : 'No'}
                  </span>
                </div>
              </Col>
            </Row>
          </div> */}
        </CardBody>
      </Card>
    )
  }

  const renderPayment = () => (
    <div>
      <h1>Payment</h1>
    </div>
  )

  const renderChangePassword = () => (
    <Card className="h-100">
      <CardBody>
        <h5 className="mb-4">Change Password</h5>
        <div className="alert alert-warning">
          <i className="ion ion-md-shield-lock me-2"></i>
          Passwords should be at least 8 characters and include a mix of
          letters, numbers, and symbols.
        </div>
        <form>
          <div className="mb-3">
            <label className="form-label">Current Password</label>
            <InputText type="password" className="w-100" />
          </div>
          <div className="mb-3">
            <label className="form-label">New Password</label>
            <InputText type="password" className="w-100" />
          </div>
          <div className="mb-3">
            <label className="form-label">Confirm New Password</label>
            <InputText type="password" className="w-100" />
          </div>
          <Button color="primary">Update Password</Button>
        </form>
      </CardBody>
    </Card>
  )

  const handlePaymentHistory = async () => {
    try {
      setPaymentHistoryLoading(true);
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await PaymentApi.getPaymentDetailsById(userData.userId, config);
      if (response.data.status) {
        setPaymentHistory(response.data.data.payments);
        setPaymentHistoryModal(true);
      } else {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: response.data.message || 'Failed to fetch payment history',
          life: 3000,
        });
      }
    } catch (error) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: error.response?.data?.message || 'Error fetching payment history',
        life: 3000,
      });
    } finally {
      setPaymentHistoryLoading(false);
    }
  };

  const handleParentDetails = async () => {
    try {
      setParentDetailsLoading(true);
      // Simulate a small delay to show loading state
      await new Promise(resolve => setTimeout(resolve, 500));
      setParentDetailsModal(true);
    } catch (error) {
      console.error("Error loading parent details:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to load parent details",
        life: 3000,
      });
    } finally {
      setParentDetailsLoading(false);
    }
  };

  const handleDeleteParent = async (parentId) => {
    try {
      // We'll use the relationship _id directly now
      setSelectedParentId(parentId);
      setDeleteParentModal(true);
    } catch (error) {
      console.error("Error in handleDeleteParent:", error);
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Error preparing to remove parent',
        life: 3000,
      });
    }
  };

  const confirmDeleteParent = async () => {
    if (!selectedParentId) return;

    try {
      setDeleteParentLoading(true);
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await AuthenticationApi.deleteParentFromStudent(userData.userId, selectedParentId, config);

      if (response.data.status) {
        // Update the userData state to remove the deleted parent using the relationship _id
        setUserData(prev => ({
          ...prev,
          childrenOf: prev.childrenOf.filter(parent => parent._id !== selectedParentId)
        }));

        toast.current.show({
          severity: 'success',
          summary: 'Success',
          detail: 'Parent removed successfully',
          life: 3000,
        });

        setDeleteParentModal(false);
        setSelectedParentId(null);
      } else {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: response.data.message || 'Failed to remove parent',
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error removing parent:", error);
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: error.response?.data?.message || 'Error while removing parent',
        life: 3000,
      });
    } finally {
      setDeleteParentLoading(false);
    }
  };

  const renderSettings = () => {
    const handleDeleteConfirmation = () => {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
      const payload = {
        deleteType: "app-user",
      }
      AuthenticationApi.deleteGabOtpConfirmation(payload, config)
        .then(response => {
          toggle()
        })
        .catch(error => {
          console.error("Error sending OTP:", error)
          toggle()
        })
    }

    const handleDeleteUser = () => {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
      const payload = {
        otp: otp,
        deletedReason: reason,
      }

      AuthenticationApi.deleteUser(userData.userId, payload, config)
        .then(response => {
          toggle()

          navigate("/user-list")
        })
        .catch(error => {
          console.error("Error deleting user:", error)
          toggle()
        })
    }

    const handleLockToggle = () => {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
      if (!userSettings.isUserLocked && !lockReason) {
        setShowLockReason(true)
        return
      }

      const requestBody = userSettings.isUserLocked ? {} : { reason: lockReason }

      AuthenticationApi.UserLockAndUnlock(userData.userId, requestBody, config)
        .then(response => {
          if (response.data.status) {
            setUserData(prev => ({
              ...prev,
              isUserLocked: !prev.isUserLocked,
              isUserLockedReason: response.data.isUserLockedReason,
            }))

            setShowLockReason(false)
            setLockReason("")
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: `User ${userData.isUserLocked ? "unlocked" : "locked"} successfully`,
              life: 3000,
            })
          }
        })
        .catch(error => {
          console.error("Error toggling user lock status:", error)
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response?.data?.message ||
              "Failed to update user lock status. Please try again!",
            life: 3000,
          })
        })
    }

    const handleStartTwoFactorSetup = () => {
      setShowTypeSelector(true)
    }

    const handleCancelTwoFactorSetup = () => {
      setShowTypeSelector(false)
    }

    const handleAuthTypeChange = newAuthType => {
      setTwoFactorAuthType(newAuthType)
    }

    const handleEnableTwoFactor = () => {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }

      const data = {
        isEnabled: true,
        authType: twoFactorAuthType,
      }

      UserSettingApi.updateTwoFactorSettings(userData.userId, data, config)
        .then(response => {
          if (response.data.status) {
            setTwoFactorEnabled(true)
            setShowTypeSelector(false)

            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: "Two-factor authentication enabled successfully",
              life: 3000,
            })
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: response.data.message || "Failed to enable 2FA",
              life: 3000,
            })
          }
        })
        .catch(error => {
          console.error("Error enabling 2FA:", error)
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: error.response?.data?.message || "Failed to enable 2FA",
            life: 3000,
          })
        })
    }

    const handleDisableTwoFactor = () => {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }

      const data = {
        isEnabled: false,
        authType: null,
      }

      UserSettingApi.updateTwoFactorSettings(userData.userId, data, config)
        .then(response => {
          if (response.data.status) {
            setTwoFactorEnabled(false)

            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: "Two-factor authentication disabled successfully",
              life: 3000,
            })
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: response.data.message || "Failed to disable 2FA",
              life: 3000,
            })
          }
        })
        .catch(error => {
          console.error("Error disabling 2FA:", error)
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: error.response?.data?.message || "Failed to disable 2FA",
            life: 3000,
          })
        })
    }

    const handleNotificationToggle = async (_notificationType_, value = null) => {
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        };

        const newValue = !userSettings[_notificationType_];

        const data = {
          [_notificationType_]: value || newValue,
        };

        const response = await UserSettingApi.updateUserSettings(
          userData.userId,
          data,
          config
        );

        if (response.data.status) {
          setUserSettings((_prev_) => ({
            ..._prev_,
            [_notificationType_]: newValue,
          }));

          toast.current.show({
            severity: "success",
            summary: "Success",
            detail:
              response.data.message ||
              "Notification setting updated successfully",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error updating notification settings:", error);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            error.response?.data?.message ||
            "Failed to update notification settings",
          life: 3000,
        });
      }
    };

    const handleResetPassword = async () => {
      try {
        setResetPasswordLoading(true);
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        };

        const response = await AuthenticationApi.resetUserPassword(userData.userId, {}, config);

        if (response.data.status) {
          toast.current.show({
            severity: 'success',
            summary: 'Success',
            detail: 'Password reset successfully. New password has been sent to user\'s email.',
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: response.data.message || 'Failed to reset password',
            life: 3000,
          });
        }
      } catch (error) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.message || 'Error while resetting password',
          life: 3000,
        });
      } finally {
        setResetPasswordLoading(false);
      }
    };

    return (
      <Card className="h-100">
        <CardBody style={{ height: "100%", overflowY: "auto" }}>
          <h5 className="mb-4">Account Settings</h5>
          <Row>
            <Col md="12" className="mb-4">
              {/* Lock and Unlock User Section */}
              <h6>Lock and Unlock User</h6>
              <div className="d-flex align-items-center justify-content-between mt-3">
                <div>
                  <h6 className="mb-1">
                    {userSettings.isUserLocked ? "Unlock User" : "Lock User"}
                  </h6>
                  <p className="text-muted small mb-0">
                    {userSettings.isUserLocked
                      ? "User is currently locked. Click to unlock."
                      : "User is currently active. Click to lock."}
                  </p>
                </div>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="lockUser"
                    defaultChecked={userSettings.isUserLocked}
                    onChange={handleLockToggle}
                  />
                </div>
              </div>
              {showLockReason && (
                <div className="mt-3">
                  <InputText
                    className="w-100 mb-2"
                    placeholder="Enter reason for locking user"
                    value={lockReason}
                    onChange={e => setLockReason(e.target.value)}
                  />
                  <div className="d-flex gap-2">
                    <Button
                      color="primary"
                      size="sm"
                      onClick={handleLockToggle}
                      disabled={!lockReason}
                    >
                      Confirm Lock
                    </Button>
                    <Button
                      color="secondary"
                      size="sm"
                      onClick={() => {
                        setShowLockReason(false)
                        setLockReason("")
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              )}
              <hr />

              {/* <div className="d-flex align-items-center justify-content-between mt-3">
                <div>
                  <h6 className="mb-1">Email Notifications</h6>
                  <p className="text-muted small mb-0">
                    Receive email updates about account activity
                  </p>
                </div>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="emailNotif"
                    checked={userSettings?.emailNotifications || false}
                    onChange={() => }
                  />
                </div>
              </div> */}

              <h6>User Settings</h6>
              <div className="notification-settings">
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <div>
                    <h6 className="mb-1">DOB</h6>
                    <p className="text-muted small mb-0">
                      DOB visibility settings
                    </p>
                  </div>
                  <Button
                    color={userSettings.isDobVisible ? "success" : "secondary"}
                    size="sm"
                    onClick={() => handleNotificationToggle('isDobVisible')}
                  >
                    {userSettings.isDobVisible ? "Enabled" : "Disabled"}
                  </Button>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <div>
                    <h6 className="mb-1">Email</h6>
                    <p className="text-muted small mb-0">
                      Email visibility settings
                    </p>
                  </div>
                  <Button
                    color={userSettings.isEmailVisible ? "success" : "secondary"}
                    size="sm"
                    onClick={() => handleNotificationToggle('isEmailVisible')}
                  >
                    {userSettings.isEmailVisible ? "Enabled" : "Disabled"}
                  </Button>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <div>
                    <h6 className="mb-1">Phone</h6>
                    <p className="text-muted small mb-0">
                      Phone visibility settings
                    </p>
                  </div>
                  <Button
                    color={userSettings.isPhoneVisible ? "success" : "secondary"}
                    size="sm"
                    onClick={() => handleNotificationToggle('isPhoneVisible')}
                  >
                    {userSettings.isPhoneVisible ? "Enabled" : "Disabled"}
                  </Button>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <div>
                    <h6 className="mb-1">Message Privacy</h6>
                    <p className="text-muted small mb-0">
                      Message Privacy Settings
                    </p>
                  </div>
                  <Button
                    color={userSettings.messagePrivacy ? "success" : "secondary"}
                    size="sm"
                    onClick={() => handleNotificationToggle('messagePrivacy', userSettings.messagePrivacy === "everyone" ? "friends" : "everyone")}
                  >
                    {userSettings.messagePrivacy === "everyone" ? "everyone" : "friends"}
                  </Button>
                </div>
              </div>
              <hr />
              <div className="d-flex align-items-center justify-content-between mt-3">
                <div>
                  <h6 className="mb-1">Two-Factor Authentication</h6>
                  <p className="text-muted small mb-0">
                    Add an extra layer of security to your account
                  </p>
                </div>
                {twoFactorEnabled ? (
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={handleDisableTwoFactor}
                  >
                    Disable
                  </button>
                ) : (
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={handleStartTwoFactorSetup}
                    disabled={showTypeSelector}
                  >
                    Enable
                  </button>
                )}
              </div>
              {showTypeSelector && !twoFactorEnabled && (
                <div className="mt-3 p-3 border rounded">
                  <h6>Setup Two-Factor Authentication</h6>
                  <div className="mb-3">
                    <label className="form-label">Authentication Method</label>
                    <Dropdown
                      value={twoFactorAuthType}
                      options={[
                        { label: "Email", value: "email" },
                        { label: "Phone", value: "phone" },
                      ]}
                      onChange={e => handleAuthTypeChange(e.value)}
                      placeholder="Select Authentication Method"
                      className="w-100"
                    />
                  </div>
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={handleCancelTwoFactorSetup}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-success btn-sm"
                      onClick={handleEnableTwoFactor}
                    >
                      Enable Two-Factor
                    </button>
                  </div>
                </div>
              )}

              {twoFactorEnabled && (
                <div className="mt-3">
                  <div className="d-flex align-items-center">
                    <span className="text-success me-2">
                      <i className="bi bi-shield-check"></i>
                    </span>
                    <span>
                      Two-factor authentication is enabled using{" "}
                      <strong>
                        {twoFactorAuthType === "email"
                          ? "Email"
                          : "phone"}
                      </strong>
                    </span>
                  </div>
                </div>
              )}
              <hr />
              <div className="d-flex align-items-center justify-content-between mt-3">
                <div>
                  <h6 className="mb-1">Reset Password</h6>
                  <p className="text-muted small mb-0">
                    Generate a new random password and send it to the user's email
                  </p>
                </div>
                <Button
                  color="primary"
                  size="sm"
                  onClick={handleResetPassword}
                  disabled={resetPasswordLoading}
                >
                  {resetPasswordLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-1" />
                      Resetting...
                    </>
                  ) : (
                    'Regenerate Password'
                  )}
                </Button>
              </div>
              <hr />
              <div className="d-flex align-items-center justify-content-between mt-3">
                <div>
                  <h6 className="mb-1">Payment History</h6>
                  <p className="text-muted small mb-0">
                    View user's payment transaction history
                  </p>
                </div>
                <Button
                  color="primary"
                  size="sm"
                  onClick={handlePaymentHistory}
                  disabled={paymentHistoryLoading}
                >
                  {paymentHistoryLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-1" />
                      Loading...
                    </>
                  ) : (
                    'View Payment History'
                  )}
                </Button>
              </div>
              <hr />
              {/* Parent Details Section */}
              <div className="d-flex align-items-center justify-content-between mt-3">
                <div>
                  <h6 className="mb-1">Parent Details</h6>
                  <p className="text-muted small mb-0">
                    View and manage parent account details
                  </p>
                </div>
                <Button
                  color="primary"
                  size="sm"
                  onClick={handleParentDetails}
                  disabled={parentDetailsLoading}
                >
                  {parentDetailsLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-1" />
                      Loading...
                    </>
                  ) : (
                    'View Parent Details'
                  )}
                </Button>
              </div>
              <hr />
              <div className="d-flex align-items-center justify-content-between mt-3 p-3 rounded" style={{ backgroundColor: 'rgba(220, 53, 69, 0.1)', border: '1px solid rgba(220, 53, 69, 0.2)' }}>
                <div>
                  <h6 className="mb-1 text-danger">Delete Account</h6>
                  <p className="text-muted small mb-0">
                    Permanently delete your account and all data
                  </p>
                </div>
                <Button
                  color="danger"
                  size="sm"
                  onClick={handleDeleteConfirmation}
                  className="btn-danger"
                  style={{ backgroundColor: '#dc3545', borderColor: '#dc3545', color: 'white' }}
                >
                  Delete
                </Button>
              </div>
            </Col>
            <hr />
            <Col md="12" className="mb-4">
              <Modal isOpen={modal} toggle={toggle} centered size="lg">
                <ModalHeader toggle={toggle}>Confirm Delete User</ModalHeader>
                <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto', padding: '20px' }}>
                  <p>
                    An OTP has been sent to admin for verification. Please enter
                    the OTP.
                  </p>

                  <div className="confirm-del-form d-flex flex-column gap-4">
                    <div className="d-flex flex-column gap-2">
                      <label htmlFor="otp">OTP</label>
                      <Input
                        id="otp"
                        type="text"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={e => setOtp(e.target.value)}
                      />
                    </div>
                    <div className="d-flex flex-column gap-1">
                      <label htmlFor="reason">Reason</label>
                      <textarea
                        id="reason"
                        placeholder="Enter Reason"
                        className="form-control"
                        value={reason}
                        onChange={e => setReason(e.target.value)}
                      />
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={toggle}>
                    Close
                  </Button>
                  <Button
                    color="primary"
                    onClick={handleDeleteUser}
                    disabled={!otp || !reason}
                  >
                    Confirm
                  </Button>
                </ModalFooter>
              </Modal>
            </Col>
          </Row>
        </CardBody>
      </Card>
    )
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case "personal-info":
        return renderPersonalInformation()
      case "View Connections":
        return renderConnections()
      case "View Posts":
        return (
          <Card className="h-100">
            <CardBody style={{ height: "100%", padding: 0 }}>
              <div style={{ height: "100%", overflowY: "auto" }}>
                {renderPosts()}
              </div>
            </CardBody>
          </Card>
        )
      case "bank-details":
        if (userData.userType !== "creator") {
          setActiveTab("personal-info");
          return renderPersonalInformation();
        }
        return renderBankDetails()
      case "change-password":
        return renderChangePassword()
      case "settings":
        return renderSettings()
      default:
        return renderPersonalInformation()
    }
  }

  return (
    <>
      <Toast ref={toast} position="top-right" life="3000" />
      <div className="view-app-user">
        {loading && (
          <div className="loader-overlay">
            <ProgressSpinner />
          </div>
        )}

        <Row>
          <Col xs="12">
            <div className="user-profile-header">
              <CustomBreadCrumb
                data={breadcrumbItems}
                pageTitle="User Profile"
                handleClick={handleBreadcrumbClick}
              />
            </div>

            <div
              style={{
                display: "flex",
                height: "calc(100vh - 150px)",
                gap: "15px",
              }}
            >
              {/* Sidebar */}
              <div style={{ flex: "0 0 33.333%" }}>
                <div style={{ height: "100%" }}>{renderSidebar()}</div>
              </div>

              {/* Main Content */}
              <div style={{ flex: "1", overflow: "hidden" }}>
                {renderTabContent()}
              </div>
            </div>
          </Col>
        </Row>
        {/* <ToastContainer /> */}
      </div>
      {/* Payment History Modal */}
      <Modal isOpen={paymentHistoryModal} toggle={() => setPaymentHistoryModal(false)} size="xl">
        <ModalHeader toggle={() => setPaymentHistoryModal(false)} className="border-bottom">
          Payment History
        </ModalHeader>
        <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto', padding: '0' }}>
          {paymentHistory.length > 0 ? (
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead className="table-light" style={{ position: 'sticky', top: '0', zIndex: 1 }}>
                  <tr>
                    <th>Order ID</th>
                    <th>Amount</th>
                    <th>Currency</th>
                    <th>Order For</th>
                    <th>Payment Status</th>
                    <th>Order Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentHistory.map((payment, index) => (
                    <tr key={index}>
                      <td style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', padding: '12px 8px' }}>
                        {payment.orderId}
                      </td>
                      <td style={{ padding: '12px 8px' }}>
                        {payment.currency === 'INR' ? '₹' : '$'}{payment.amount}
                      </td>
                      <td style={{ padding: '12px 8px' }}>{payment.currency}</td>
                      <td style={{ padding: '12px 8px' }}>
                        {payment.orderFor === 'CIRCLE' && (
                          <div>
                            <div>{payment.orderForDetails?.circleName || 'hi-Anisha'}</div>
                            <small className="text-muted">Circle</small>
                          </div>
                        )}
                      </td>
                      <td style={{ padding: '12px 8px' }}>
                        <span className={`badge ${payment.paymentStatus === 'SUCCESS' ? 'bg-success' :
                          payment.paymentStatus === 'PENDING' ? 'bg-warning' :
                            payment.paymentStatus === 'COMPLETED' ? 'bg-success' :
                              'bg-danger'
                          }`} style={{ textTransform: 'capitalize' }}>
                          {payment.paymentStatus.toLowerCase()}
                        </span>
                      </td>
                      <td style={{ padding: '12px 8px' }}>
                        <span className={`badge ${payment.orderStatus === 'SUCCESS' ? 'bg-success' :
                          payment.orderStatus === 'ACTIVE' ? 'bg-success' :
                            payment.orderStatus === 'PENDING' ? 'bg-warning' :
                              'bg-danger'
                          }`} style={{ textTransform: 'capitalize' }}>
                          {payment.orderStatus.toLowerCase()}
                        </span>
                      </td>
                      <td style={{ padding: '12px 8px' }}>{new Date(payment.orderDetails?.created_at).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-4">
              <p className="text-muted mb-0">No payment history found</p>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setPaymentHistoryModal(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Add Parent Details Modal */}
      <Modal isOpen={parentDetailsModal} toggle={() => setParentDetailsModal(false)} size="xl">
        <ModalHeader toggle={() => setParentDetailsModal(false)} className="border-bottom">
          Parent Details
        </ModalHeader>
        <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto', padding: '20px' }}>
          {userData.childrenOf && userData.childrenOf.length > 0 ? (
            <Row>
              {userData.childrenOf.map((parent, index) => (
                <Col md="6" key={index} className="mb-4">
                  <Card>
                    <CardBody>
                      <div className="d-flex align-items-center mb-3">
                        <img
                          src={parent.parentDetails.profilePicture || defaultAvatar}
                          alt={parent.parentDetails.firstName}
                          className="rounded-circle me-3"
                          width="60"
                          height="60"
                          style={{ objectFit: "cover" }}
                        />
                        <div>
                          <h6 className="mb-1">{`${parent.parentDetails.firstName} ${parent.parentDetails.lastName}`}</h6>
                          <p className="text-muted small mb-0">@{parent.parentDetails.userName}</p>
                          <p className="text-muted small mb-0">{parent.parentDetails.email}</p>
                        </div>
                      </div>
                      <div className="mt-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="text-muted">Relationship:</span>
                          <span className="text-capitalize">{parent.relationship}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-2">
                          <span className="text-muted">Status:</span>
                          <span className={`badge ${parent.status === 'approved' ? 'bg-success' :
                            parent.status === 'pending' ? 'bg-warning' :
                              'bg-danger'
                            }`}>
                            {parent.status}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-2">
                          <span className="text-muted">User Type:</span>
                          <span className="text-capitalize">{parent.userType}</span>
                        </div>
                        <div className="mt-3">
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleDeleteParent(parent._id)}
                            className="remove-parent-btn"
                          >
                            Remove Parent
                          </Button>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <div className="text-center py-4">
              <p className="text-muted mb-0">No parent details found</p>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setParentDetailsModal(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Add this modal component before the closing fragment */}
      <Modal isOpen={deleteParentModal} toggle={() => setDeleteParentModal(false)} centered size="lg">
        <ModalHeader toggle={() => setDeleteParentModal(false)}>Confirm Parent Removal</ModalHeader>
        <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto', padding: '20px' }}>
          <p>Are you sure you want to remove this parent? This action cannot be undone.</p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setDeleteParentModal(false)}>
            Cancel
          </Button>
          <Button
            color="danger"
            onClick={confirmDeleteParent}
            disabled={deleteParentLoading}
          >
            {deleteParentLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" />
                Removing...
              </>
            ) : (
              'Remove Parent'
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default ViewAppUser
